import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './router/appRoutes';
import RootLayout from './layout/RootLayout';
import DashboardLayout from './layout/DashboardLayout';
import './styles/app.css';
import Home from './pages/HomePage';
import Login from './components/auth/Login';
import Signup from './components/users/Register';
import ProfilePage from './pages/ProfilePage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectsDetails from './components/ProjectsDetails';
import ContactPage from './pages/ContactPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import AboutPage from './pages/AboutPage';
import BlogsPage from './pages/BlogsPage';
import BlogDetails from './components/BlogDetails';
import NotFoundBlogPage from './pages/NotFoundBlogPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import NotFound from './pages/NotFoundPage';
import Spinner from "./components/Spinner";
import ScrollToTop from "./components/ScroolToTop";

// Dashboard (lazy-loaded)
const DashboardAddUser = lazy(() => import("./components/dashboard/DashboardAddUser"));
const DashboardUsersData = lazy(() => import("./components/dashboard/DashboardUsersData"));
const DashboardProjects = lazy(() => import("./components/dashboard/DashboardProjects"));
const DashboardNotFound = lazy(() => import("./components/dashboard/DashboardNotFound"));


function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Spinner />}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RootLayout />}>
            <Route index element={<Home />} />
            <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} />} />
            <Route path={ROUTES.LOGIN} element={<Login />} />
            <Route path={ROUTES.REGISTER} element={<Signup />} />
            <Route path={ROUTES.DASHBOARD_PROFILE} element={<ProfilePage />} />
            <Route path={ROUTES.CONTACT} element={<ContactPage />} />
            <Route path={ROUTES.ABOUT} element={<AboutPage />} />
            <Route path={ROUTES.PROJECTS} element={<ProjectsPage />} />
            <Route path={ROUTES.PROJECT_DETAILS} element={<ProjectsDetails />} />
            <Route path={ROUTES.BLOGS} element={<BlogsPage />} />
            <Route path={ROUTES.BLOGS_INFO} element={<BlogDetails />} />
            <Route path={ROUTES.BLOGS_NOT_FOUND} element={<NotFoundBlogPage />} />
            <Route path={ROUTES.USERS} element={<UsersPage />} />
            <Route path={ROUTES.UNAUTHORIZED} element={<UnauthorizedPage />} />
            <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
          </Route>

          <Route path={ROUTES.DASHBOARD} element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="*" element={<Navigate to={ROUTES.DASHBOARD_NOT_FOUND} />} />
            <Route path={ROUTES.DASHBOARD_PROJECTS} element={<DashboardProjects />} />
            <Route path={ROUTES.DASHBOARD_USERS} element={<DashboardUsersData />} />
            <Route path={ROUTES.DASHBOARD_USERS_ADD} element={<DashboardAddUser />} />
            <Route path={ROUTES.DASHBOARD_UNAUTHORIZED} element={<UnauthorizedPage />} />
            <Route path={ROUTES.DASHBOARD_NOT_FOUND} element={<DashboardNotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App 
